import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useSearchStore from '../../store/useSearchStore';
import useComparisonStore from '../../store/useComparisonStore';
import SearchResultCard from '../SearchResultCard/SearchResultCard';
import {
  ResultsContainer,
  ResultsList,
  LoadingState,
  EmptyState,
  LoadingOverlay,
} from './searchResults.style';

const SearchResults = ({ onAddToCart, onToggleCompare }) => {
  const { t } = useTranslation();
  // Get state from stores
  const {
    tyres,
    loading,
    openTyreId,
    addToCartLoadingId,
    quantities,
    defaultQuantity,
    toggleTyreExpand,
    setQuantity,
    setDeliveryDate,
    refreshDelivery,
  } = useSearchStore();

  const { tyres: comparisonTyres, isFull } = useComparisonStore();

  const handleQuantityChange = (tyreId, quantity) => {
    setQuantity(tyreId, quantity);
  };

  const handleDeliveryDateChange = (tyreId, date) => {
    setDeliveryDate(tyreId, date);
  };

  if (loading && !tyres.length) {
    return (
      <ResultsContainer>
        <LoadingState>
          <i className="mdi mdi-loading" />
          <p>{t('loadingResults')}</p>
        </LoadingState>
      </ResultsContainer>
    );
  }

  if (!loading && !tyres.length) {
    return (
      <ResultsContainer>
        <EmptyState>
          <i className="mdi mdi-magnify" />
          <p>{t('noSearchResults')}</p>
        </EmptyState>
      </ResultsContainer>
    );
  }

  return (
    <ResultsContainer>
      {loading && tyres.length > 0 && <LoadingOverlay />}
      <ResultsList isLoading={loading && tyres.length > 0}>
        {tyres.map((tyre) => {
          const isInComparison = comparisonTyres.some(
            (t) => t._id === tyre._id
          );
          const isComparisonFull = isFull();

          return (
            <SearchResultCard
              key={tyre._id}
              tyre={tyre}
              isOpen={openTyreId === tyre._id}
              onToggle={toggleTyreExpand}
              quantity={quantities[tyre._id] || tyre.cartQuantity || defaultQuantity}
              onQuantityChange={handleQuantityChange}
              onAddToCart={onAddToCart}
              isAddingToCart={addToCartLoadingId === tyre._id}
              onDeliveryDateChange={handleDeliveryDateChange}
              onRefreshDelivery={refreshDelivery}
              isInComparison={isInComparison}
              onToggleCompare={onToggleCompare}
              isComparisonFull={isComparisonFull}
            />
          );
        })}
      </ResultsList>
      {loading && tyres.length > 0 && (
        <LoadingState>
          <i className="mdi mdi-loading" />
          <p>{t('loadingMoreResults')}</p>
        </LoadingState>
      )}
    </ResultsContainer>
  );
};

SearchResults.propTypes = {
  onAddToCart: PropTypes.func.isRequired,
  onToggleCompare: PropTypes.func,
};

export default SearchResults;
